import { render, staticRenderFns } from "./TableKpiItem.vue?vue&type=template&id=622ee3e4"
import script from "./TableKpiItem.vue?vue&type=script&lang=ts"
export * from "./TableKpiItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports